module.exports = __webpack_public_path__ + "img/bespoke123_26.d7395570.jpg";